/**
 * Loads heavier theme feature scripts after idle / near viewport / first use.
 * Interaction handlers ensure ATC, accordion, and quick-view never fail if the
 * user acts before the deferred load finishes.
 */
(function () {
  var urls = window.FoxThemeDeferredScripts;
  if (!urls) return;

  var inflight = {};
  var loaded = {};

  function whenDefined(name) {
    if (customElements.get(name)) return Promise.resolve();
    if (customElements.whenDefined) return customElements.whenDefined(name);
    return Promise.resolve();
  }

  function inject(url, id) {
    if (loaded[id]) return Promise.resolve();
    if (inflight[id]) return inflight[id];

    inflight[id] = new Promise(function (resolve, reject) {
      if (document.querySelector('script[data-deferred-script="' + id + '"]')) {
        loaded[id] = true;
        resolve();
        return;
      }

      var script = document.createElement('script');
      script.src = url;
      script.defer = true;
      script.dataset.deferredScript = id;
      script.onload = function () {
        loaded[id] = true;
        resolve();
      };
      script.onerror = function () {
        delete inflight[id];
        reject(new Error('Failed to load ' + id));
      };
      document.body.appendChild(script);
    });

    return inflight[id];
  }

  function loadProductForm() {
    if (!urls.productForm) return Promise.resolve();
    return inject(urls.productForm, 'product-form').then(function () {
      return whenDefined('product-form');
    });
  }

  function loadCollapsibleTab() {
    if (!urls.collapsibleTab) return Promise.resolve();
    return inject(urls.collapsibleTab, 'collapsible-tab').then(function () {
      return whenDefined('collapsible-tab');
    });
  }

  function loadQuickView() {
    if (!urls.quickView) return Promise.resolve();
    return inject(urls.quickView, 'quick-view');
  }

  window.FoxThemeLoadProductForm = loadProductForm;
  window.FoxThemeLoadCollapsibleTab = loadCollapsibleTab;
  window.FoxThemeLoadQuickView = loadQuickView;

  function onIdle(fn, timeout) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: timeout || 2500 });
    } else {
      setTimeout(fn, timeout || 1);
    }
  }

  function observeAndLoad(selector, loader, rootMargin) {
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      loader();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        io.disconnect();
        loader();
      },
      { rootMargin: rootMargin || '300px 0px' }
    );

    nodes.forEach(function (node) {
      io.observe(node);
    });
  }

  // --- Eager paths (critical above-the-fold features) ---
  if (urls.eagerProductForm) {
    loadProductForm();
  } else if (urls.productForm) {
    observeAndLoad('product-form', loadProductForm, '400px 0px');
    onIdle(function () {
      if (document.querySelector('product-form')) loadProductForm();
    }, 3000);
  }

  if (urls.eagerCollapsibleTab) {
    loadCollapsibleTab();
  } else if (urls.collapsibleTab) {
    observeAndLoad('collapsible-tab', loadCollapsibleTab, '200px 0px');
    onIdle(function () {
      if (document.querySelector('collapsible-tab')) loadCollapsibleTab();
    }, 2000);
  }

  if (urls.quickView) {
    if (document.querySelector('[data-product-quickview]')) {
      onIdle(function () {
        loadQuickView();
      }, 4000);
    }
  }

  // --- First-interaction fallbacks (never drop a click/submit) ---
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.closest) return;
      var host = form.closest('product-form');
      if (!host || customElements.get('product-form') || !urls.productForm) return;

      event.preventDefault();
      event.stopPropagation();

      loadProductForm().then(function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (urls.collapsibleTab && target.closest('mobile-nav-toggle, .mobile-nav-toggle')) {
        loadCollapsibleTab();
      }

      var trigger = target.closest('collapsible-tab [data-trigger]');
      if (trigger && urls.collapsibleTab && !customElements.get('collapsible-tab')) {
        event.preventDefault();
        event.stopPropagation();
        loadCollapsibleTab().then(function () {
          trigger.click();
        });
        return;
      }

      if (!urls.quickView || window.QuickView) return;

      var quickViewBtn = target.closest('[data-product-quickview]');
      if (!quickViewBtn) return;

      event.preventDefault();
      event.stopPropagation();
      quickViewBtn.classList.add('btn--loading');

      loadQuickView()
        .then(function () {
          quickViewBtn.click();
        })
        .catch(function () {
          quickViewBtn.classList.remove('btn--loading');
        });
    },
    true
  );
})();
